module.exports = __webpack_public_path__ + "static/media/Kommune_2026_Logo.3c1d468d.png";